import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import { IconContext } from "react-icons";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useUiStore } from "hooks/useUiStore";
import { useReSizeWindow } from "hooks/useResizeWindow";
import { useHomeStore } from "hooks/useHomeStore";

interface SidenavPropsInterface {
  selectedIndex: number;
  handleListItemClick: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => void;
  [x: string]: any;
}

export const SidenavOptions = ({
  selectedIndex,
  route,
  handleListItemClick,
}: SidenavPropsInterface) => {
  const { handleOpenDrawer } = useUiStore();
  const { changeHomeInitial } = useHomeStore();
  const [dropdown, setDropdown] = useState(true);

  const { screenIsOnLandscape } = useReSizeWindow();

  const handleClickDropdown = () => {
    if (!screenIsOnLandscape) {
      if (route.children.length) {
        setDropdown(!dropdown);
      } else {
        handleOpenDrawer(false);
      }
    } else {
      setDropdown(!dropdown);
    }
  };

  const handleClickChilds = () => {
    if (!screenIsOnLandscape) {
      handleOpenDrawer(false);
    }
  };

  return (
    <>
      <NavLink to={route.path ? route.path : "#"}>
        {({ isActive }) => (
          <ListItemButton
            sx={{
              borderRadius: "2rem",
              marginBottom: "5px",
              fontFamily: "Poppins",
            }}
            selected={selectedIndex === route.id}
            onClick={(event) => {
              changeHomeInitial();
              handleClickDropdown();
              handleListItemClick(event, route.id);
            }}
          >
            <ListItemIcon
              sx={{ borderRadius: "50% !important" }}
              className={
                isActive && !route.children.length
                  ? "bg-gradient-to-tl from-red-700 to-red-400"
                  : ""
              }
            >
              <IconContext.Provider
                value={{
                  className: `text-xl ${
                    isActive && !route.children.length ? "text-white" : ""
                  }`,
                }}
              >
                {route.icon}
              </IconContext.Provider>
            </ListItemIcon>
            <ListItemText
              primary={route.title}
              disableTypography
              sx={{
                borderRadius: "8px",
                marginBottom: "5px",
                fontFamily: "Poppins",
                fontSize: "14px",
              }}
            />
            {route.children.length ? (
              dropdown ? (
                <MdExpandLess />
              ) : (
                <MdExpandMore />
              )
            ) : null}
          </ListItemButton>
        )}
      </NavLink>
      {route.children.length > 0 ? (
        <Collapse in={!dropdown} timeout="auto" unmountOnExit>
          {route.children.map((child: any) =>
            child.isExternal ? (
              <a
                href={child.path}
                target="_blank"
                rel="noreferrer"
                key={child.id}
                onClick={() =>
                  child.onClickAction ? child.onClickAction() : null
                }
              >
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }}>
                    <ListItemIcon>{child.icon}</ListItemIcon>
                    <ListItemText
                      primary={child.title}
                      disableTypography
                      sx={{
                        fontWeight: 300,
                        fontFamily: "Poppins",
                        fontSize: "12px",
                      }}
                    />
                  </ListItemButton>
                </List>
              </a>
            ) : child.onClickAction ? (
              <List component="div" disablePadding key={child.id}>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => child.onClickAction()}
                >
                  <ListItemIcon>
                    <IconContext.Provider
                      value={{
                        className: ``,
                      }}
                    >
                      {child.icon}
                    </IconContext.Provider>
                  </ListItemIcon>
                  <ListItemText
                    primary={child.title}
                    disableTypography
                    sx={{
                      fontWeight: 300,
                      fontSize: "12px",
                      fontFamily: "Poppins",
                    }}
                  />
                </ListItemButton>
              </List>
            ) : (
              <NavLink to={child.path} key={child.id}>
                {({ isActive }) => (
                  <List component="div" disablePadding>
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={(event) => {
                        handleClickChilds();
                        handleListItemClick(event, route.id);
                      }}
                    >
                      <ListItemIcon
                        className={
                          isActive
                            ? "bg-gradient-to-tl from-red-700 to-red-400"
                            : ""
                        }
                      >
                        <IconContext.Provider
                          value={{
                            className: `text-lg ${
                              isActive ? "text-white" : ""
                            }`,
                          }}
                        >
                          {child.icon}
                        </IconContext.Provider>
                      </ListItemIcon>
                      <ListItemText
                        primary={child.title}
                        disableTypography
                        sx={{
                          fontWeight: 300,
                          fontSize: "12px",
                          fontFamily: "Poppins",
                        }}
                      />
                    </ListItemButton>
                  </List>
                )}
              </NavLink>
            )
          )}
        </Collapse>
      ) : null}
    </>
  );
};
